import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';  
import { Subject }    from 'rxjs';
import {TreeNode} from 'primeng/api';
import { ReplaySubject } from 'rxjs';
@Injectable()
export class EventsService 
{
  private bhsTreeNodeSelect:Subject<TreeNode>;
  private bhsTreeNodeUnSelect:Subject<TreeNode>;
  private bhsTreeSelectedNodesList:Subject<TreeNode[]>;
  private bhsOlFeatureSelect:Subject<any>;  
  private bhsOlFeatureUnSelect:Subject<any>;  
  private bhsResizeDom:Subject<any>;   
  private bhsTreeLayerNodeONoff:Subject<any>;
  private bhsMidChange:Subject<any>;
  private $cancleDrawEvent: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  private $treeNodeSelectObservable:Observable<TreeNode>;
  private $treeNodeUnSelectObservable:Observable<TreeNode>;
  private $treeSelectedNodesListObservable:Observable<TreeNode[]>;
  private $bhsOlFeatureSelectObservable:Observable<any>;  
  private $bhsOlFeatureUnSelectObservable:Observable<any>; 
  private $bhsResizeDomObservable:Observable<any>;  
  private $bhsTreeLayerNodeONoff:Observable<any>;  
  private $bhsMidChangeObservable:Observable<any>;
  private $onRemoteBtnEmit: ReplaySubject<any> = new ReplaySubject<any>();
  private $editArea: ReplaySubject<any> = new ReplaySubject<any>();

  
  private sCountVisibleLegends:Subject<any>; 
  private $CountVisibleLegendsObservable:Observable<any>;

  private sVisibleTree:Subject<any>; 
  private $sVisibleTreeObservable:Observable<any>;

  constructor() 
  { 
      this.bhsTreeNodeSelect = new Subject<TreeNode>();
      this.bhsTreeNodeUnSelect = new Subject<TreeNode>();
      this.bhsTreeSelectedNodesList = new Subject<TreeNode[]>();
      this.bhsOlFeatureSelect= new Subject<any>();
      this.bhsOlFeatureUnSelect= new Subject<any>();
      this.bhsResizeDom = new Subject<any>();
      this.bhsTreeLayerNodeONoff = new Subject<any>();
      this.bhsMidChange =  new Subject<any>();
      this.sCountVisibleLegends =  new Subject<any>();
      this.sVisibleTree =  new Subject<any>();
      
      this.$treeNodeSelectObservable = this.bhsTreeNodeSelect.asObservable();
      this.$treeNodeUnSelectObservable = this.bhsTreeNodeUnSelect.asObservable();
      this.$treeSelectedNodesListObservable = this.bhsTreeSelectedNodesList.asObservable();
      this.$bhsOlFeatureSelectObservable = this.bhsOlFeatureSelect.asObservable();
      this.$bhsOlFeatureUnSelectObservable = this.bhsOlFeatureUnSelect.asObservable();  
      this.$bhsResizeDomObservable = this.bhsResizeDom.asObservable();
      this.$bhsTreeLayerNodeONoff = this.bhsTreeLayerNodeONoff.asObservable();
      this.$bhsMidChangeObservable = this.bhsMidChange.asObservable();
      this.$CountVisibleLegendsObservable = this.sCountVisibleLegends.asObservable();
      this.$sVisibleTreeObservable = this.sVisibleTree.asObservable();
  }

  
  public  setVisibleTreeEvt(f:boolean)
  {
      this.sVisibleTree.next(f);
  }
  
  public subscribeVisibleTreeListener():Observable<any>
  {
      return this.$sVisibleTreeObservable;
  }
  
  public  setVisibleLegendsEvt(f:any)
  {
      this.sCountVisibleLegends.next(f);
  }
  
  public subscribeCountVisibleLegendsListener():Observable<any>
  {
      return this.$CountVisibleLegendsObservable;
  }
  
  public  sendMidChangeEvt(f:any)
  {
      this.bhsMidChange.next(f);
  }
  
  public subscribeMidChangeEvtListener():Observable<any>
  {
      return this.$bhsMidChangeObservable;
  }
  
  public  sendTreeNodeOnOffEvt(f:any)
  {
      this.bhsTreeLayerNodeONoff.next(f);
  }
  
  public subscribeTreeNodeOnOffEvtListener():Observable<any>
  {
      return this.$bhsTreeLayerNodeONoff;
  }
  
  public  sendDomResizeEvt(f:any)
  {
      this.bhsResizeDom.next(f);
  }
  
  public subscribeResizeDomListener():Observable<any>
  {
      return this.$bhsResizeDomObservable;
  }

  public emitOnRemoteBtnEmit(e){
    this.$onRemoteBtnEmit.next(e);
    return;
  }

  public getOnRemoteBtnEmit(): Observable<any>{
    return this.$onRemoteBtnEmit.asObservable();
  }
  
  public  sendSelectOlFeature(f:any)
  {
      this.bhsOlFeatureSelect.next(f);
  }
  
  public subscribeOlFeatureSelectListener():Observable<any>
  {
      return this.$bhsOlFeatureSelectObservable;
  }
  
  public  sendUnSelectOlFeature(f:any)
  {
      this.bhsOlFeatureUnSelect.next(f);
  }
  
  public subscribeOlFeatureUnSelectListener():Observable<any>
  {
      return this.$bhsOlFeatureUnSelectObservable;
  }
  
  
  public emitEditArea(value){
    this.$editArea.next(value);
    return;
  }

  public listenOnEditArea(): Observable<any>{
    return this.$editArea.asObservable();
  }
  public  sendSelectNode(node:TreeNode)
  {
      this.bhsTreeNodeSelect.next(node);
  }
  
  public subscribeNodeSelectListener():Observable<TreeNode>
  {
      return this.$treeNodeSelectObservable;
  }
  
  public  sendUnSelectNode(node:TreeNode)
  {
      this.bhsTreeNodeUnSelect.next(node);
  }
  
  public subscribeNodeUnSelectListener():Observable<TreeNode>
  {
      return this.$treeNodeUnSelectObservable;
  }
  
  public  sendSelectedNodeList(nodes:TreeNode[])
  {
      this.bhsTreeSelectedNodesList.next(nodes);
  }
  
  public subscribeNodeListSelectionListener():Observable<TreeNode[]>
  {
      return this.$treeSelectedNodesListObservable;
  }


  public emitCancleDrawEvent(isCancle: boolean): void{
    this.$cancleDrawEvent.next(isCancle);
    console.warn("emitCancleDrawEvent", isCancle)
    return;
  }

  public listenCancleDrawEvent(): Observable<boolean> {
    return this.$cancleDrawEvent.asObservable();
  }

  private openMolDocsSource = new Subject<any>();

  emitOpenMolDocs(data: any) {
    this.openMolDocsSource.next(data);
  }

  getOpenMolDocs() {
    return this.openMolDocsSource.asObservable();
  }
}
